export default __webpack_public_path__ + "static/media/acorn-75.185e2ac6.png";